import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { AllowedDocumentTemplateType } from './types'
import { useBoardContext } from 'dataProviders/Board'
import DocumentTemplates, {
  DocumentTemplateItem
} from 'routes/Board/DocumentTemplates'
import {
  ButtonGroup
} from 'react-bootstrap'
import Button from 'components/Button'
import { BoardModalView, ViewBody } from 'components/Sidebar'
import styled from 'styled-components'

const ButtonsWrapper = styled(ViewBody)`
  margin-top: 10px;
  margin-bottom: 10px;
`

type DocumentTemplateItem = {
  type: AllowedDocumentTemplateType;
  documentTemplateSourceId: number;
  identifier?: number;
}

const DocumentTemplateSettingsSelector: React.FC<LeftSidebarProps & {
  onAdd: (items: DocumentTemplateItem[]) => void
}> = ({
  leftSidebar,
  onAdd,
}) => {
  const [selectedItems, setSelectedItems] = useState<DocumentTemplateItem[]>([])

  const boardContext = useBoardContext()

  const close = () => {
    leftSidebar.pop()
  }

  return (
    <BoardModalView
      title={
        <FormattedMessage id='DOCUMENT_LIST_SETTINGS_ALLOWED_DOCUMENT_TEMPLATES_ADD_SELECT_HEADER' />
      }
    >
      <DocumentTemplates
        boardId={boardContext.id}
        documentTemplateComponent={(props) =>
          <DocumentTemplateItem
            {...props}
            selectable
            selected={
              Boolean(selectedItems.find(item =>
                item.type === props.type &&
                item.documentTemplateSourceId === props.documentTemplateSourceId &&
                item.identifier === props.identifier
              ))
            }
            onSelect={() => {
              setSelectedItems(selectedItems => {

                const index = selectedItems.findIndex(item =>
                  item.type === props.type &&
                  item.documentTemplateSourceId === props.documentTemplateSourceId &&
                  item.identifier === props.identifier
                )

                if (index === -1) {
                  return [
                    ...selectedItems,
                    {
                      type: props.type,
                      documentTemplateSourceId: props.documentTemplateSourceId,
                      identifier: props.identifier,
                    }
                  ]
                }

                return [
                  ...selectedItems.slice(0, index),
                  ...selectedItems.slice(index + 1)
                ]
              })
            }}
          />
        }
      />
      <ButtonsWrapper>
        <ButtonGroup>
          <Button
            bsStyle='primary'
            icon={<KanBoIcon name='kanbo-16-plus' />}
            disabled={selectedItems.length === 0}
            onClick={() => {
              onAdd(selectedItems)

              close()
            }}
          >
            <FormattedMessage
              id='ADD_SELECTED_WITH_COUNT'
              values={{
                count: selectedItems.length || null
              }}
            />
          </Button>
          <Button onClick={close}>
            <FormattedMessage id='CANCEL' />
          </Button>
        </ButtonGroup>
      </ButtonsWrapper>
    </BoardModalView>
  )
}

export default withLeftSidebar(DocumentTemplateSettingsSelector)
